import { render, staticRenderFns } from "./QuestionTagPicker.vue?vue&type=template&id=0310cd25&"
import script from "./QuestionTagPicker.vue?vue&type=script&lang=ts&"
export * from "./QuestionTagPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports